module.exports = __webpack_public_path__ + "7ab484bc95d47699dc3a71aa2075eb5c.svg";